import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomMoreActionTooltip = withStyles({
   tooltip: {
      '&.MuiTooltip-tooltip': {
         padding: 0,
         borderRadius: '6px',
         fontFamily: "'Montserrat', san-serif",
      },
   },
})(Tooltip);

const LeaveTooltip = (props) => {
   const { t } = useTranslation();

   return (
      <div className='w-full overflow-hidden'>
         <CustomMoreActionTooltip
            title={
               <div className='p-3'>
                  {props.noLeaves === true ? (
                     <p className='text-sm'>{t('common.content-123')}</p>
                  ) : (
                     <p className='text-sm'>{t('common.content-124', props)}</p>
                  )}
               </div>
            }
            placement='top'
            arrow
         >
            <div>{props.children}</div>
         </CustomMoreActionTooltip>
      </div>
   );
};

export default LeaveTooltip;
